import { render, staticRenderFns } from "./CloseDealList.vue?vue&type=template&id=00035131&scoped=true&"
import script from "./CloseDealList.vue?vue&type=script&lang=js&"
export * from "./CloseDealList.vue?vue&type=script&lang=js&"
import style0 from "./CloseDealList.vue?vue&type=style&index=0&id=00035131&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00035131",
  null
  
)

export default component.exports